import { render } from "./DialysisSectionDetailsEMROATS.vue?vue&type=template&id=6910fb6a&scoped=true"
import script from "./DialysisSectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./DialysisSectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./DialysisSectionDetailsEMROATS.vue?vue&type=style&index=0&id=6910fb6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6910fb6a"],['__file',"src/components/DialysisSectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6910fb6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6910fb6a', __exports__)) {
    api.reload('6910fb6a', __exports__)
  }
  
  module.hot.accept("./DialysisSectionDetailsEMROATS.vue?vue&type=template&id=6910fb6a&scoped=true", () => {
    api.rerender('6910fb6a', render)
  })

}


export default __exports__